<template>
  <b-card>
    <FormBuilder
      label="Brand"
      update
      :data="$store.state.brand.detailData"
      :fields="fields"
      :loading-detail="$store.state.brand.loadingDetail"
      :loading-submit="$store.state.brand.loadingSubmit"
      @load="loadData"
      @submit="submitData"
      @reset="resetData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/brand'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('brand/getDetail', id)
    },
    submitData(id, data, callback) {
      this.$store.dispatch('brand/update', { id, data })
        .then(callback)
    },
    resetData() {
      return this.$store.commit('brand/SET_DETAIL_DATA', undefined)
    },
  },
}
</script>

<style scoped>

</style>
